import { PlusOutlined } from "@ant-design/icons"
import { Button } from "antd"
import { Suspense, lazy, useState } from "react"
import { useTranslation } from "react-i18next"

import { type PermissionLabelFormData } from "../types/permissions.types.ts"

const PermissionsLabelModal = lazy(() =>
  import("./PermissionsLabelModal.tsx").then((m) => ({
    default: m.PermissionsLabelModal
  }))
)

interface PermissionsLabelControllerProps {
  onAddLabel: (data: PermissionLabelFormData) => Promise<void>
  existingNames?: string[]
}

export function PermissionsLabelController({
  onAddLabel,
  existingNames
}: PermissionsLabelControllerProps) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        className={"ml-2"}
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setOpen(true)}
      >
        {t("permissions.editor.addRole")}
      </Button>

      <Suspense fallback={null}>
        {open && (
          <PermissionsLabelModal
            open={open}
            onClose={() => setOpen(false)}
            onSubmit={onAddLabel}
            existingNames={existingNames}
          />
        )}
      </Suspense>
    </>
  )
}
